module.exports = __webpack_public_path__ + "img/flower-top.6b59c910.png";